<template>
  <div>
    <el-form
      :model="listForm"
      ref="listForm"
      inline="true"
      :rules="releaseRules"
      class="editForm"
      label-width="120px"
    >
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="20">
          <el-form-item label="计薪周期" prop="calpaydate">
            <el-select  v-model="listForm.calpayStartMonth"   placeholder="选择月次" style="width:110px;margin-right:10px;" @change="chagePayMonth">
              <el-option  v-for="item in dataOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select  v-model="listForm.calpayStartDay"   placeholder="选择日期" style="width:110px;margin-right:10px;" @change="chagePayMonth">
              <el-option  v-for="item in dataNum" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <span style="word-spacing:6px;margin-right:10px;vertical-align: top;">日  至</span>
            <el-select  v-model="listForm.calpayEndMonth"   placeholder="选择月次" style="width:110px;margin-right:10px;" @change="chagePayMonth">
              <el-option  v-for="item in dataOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select  v-model="listForm.calpayEndDay"   placeholder="选择日期" style="width:110px;margin-right:10px;" @change="chagePayMonth">
              <el-option  v-for="item in dataNum" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <span style="vertical-align: top;">日</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
          <el-col :span="20">
            <el-form-item label="对应社保月份" prop="socMonth">
              <el-select  v-model="listForm.socMonth"   placeholder="选择月次" style="width:160px;" @change="chagePayMonth">
                <el-option  v-for="item in dataOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发薪日期" prop="payDate">
              <el-select  v-model="listForm.payMonth"   placeholder="选择月次" style="width:110px;margin-right:10px;" @change="chagePayMonth">
                <el-option  v-for="item in dataOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select  v-model="listForm.payDay"   placeholder="选择日期" style="width:110px;margin-right:10px;" @change="chagePayMonth">
                <el-option  v-for="item in dataNum" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <span style="vertical-align: top;">日</span>
            </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="20">
          <el-form-item label="所属薪酬组" prop="payGroupId">
            <!-- 调用树形下拉框组件 -->
            <ciic-tree-select ref="payGroupId" style="width:520px;" :props="props" :options="treeList2"
            :value="listForm.payGroupId" @getValue="getValue($event)" :showFilter="true" :multiple="false"
            :expand="true" >
            </ciic-tree-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import bspSelectTree from "@/components/bsp/bsp-select-tree/bsp-select-tree";
import bspDictsSelect from "@/components/bsp/bsp-dicts-select/bsp-dicts-select";
import { isvalidatemobile, cardid } from "@/util/validate";
import CiicTreeSelect from "@/components/ciic/ciic-tree-select/ciic-tree-select";
import { init,codeList,codeToName,nameToCode,getCodeNames,getNameCodes} from "@/components/bsp/code/frontCode";
import store from "@/store";
import {queryCompanyOrgList} from "@/api/sys/sys";
import {queryPmsPayGroupTree,getGroupTree} from "@/api/wage/payGroup";
import { mapGetters } from 'vuex';
import { commonConst } from '@/const/code.js'
import { isNull } from 'xe-utils/methods';


export default {
  components: {
    CiicTreeSelect,
    bspDictsSelect,
    bspSelectTree
  },
  computed: {
    ...mapGetters([
      'dicts',
    ]),
  },
  name: "Dialog",
  props: {
    listForm: {
      type: Object,
      default: () => ({})
    },
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    dialogStatus: {
      type: String,
      default: ""
    }
  },
  watch: {
    listForm: {
      handler(newVal, oldVal) {
        // 在监听你使用update事件来更新listForm,而在父组件不需要调用该函数
        this.$emit("update:listForm", newVal);
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    init('city');
    /*console.log("行政区划：",cityList);
    console.log("行政区划：",codeToName);
    console.log("行政区划：",codeToName[ "120000", "120100", "120101"]);
    console.log("行政区划fanyi1：",getCodeNames("120000,120100,120101"));
    console.log("行政区划fanyi2：",getNameCodes("北京市,北京市,昌平区"));
    console.log("行政区划：",nameToCode);*/
    for (var i=1;i<=31;i++){
      let params = {
        value:'',
        label:''
      };
      params.value=i;
      params.label=i;
      this.dataNum.push(params);
    };
    //调用方法获取组织机构 改为获取薪酬组
    // this.getOrgTree(store.getters.cusId);
    this.queryPmsPayGroupTree();
  },
  mounted() {},
  data() {
    const validateIdcard = (rule, value, callback) => {
      if (this.listForm.idType == "00340001") {
        if (cardid(value)[0]) {
          callback(new Error(cardid(value)[1]));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      options: codeList,
      dataOptions:[
        {
          value:commonConst.COMPANY_CURRENT_MONTH,
          label:'当月'
        },
        {
          value:commonConst.COMPANY_NEXT_MONTH,
          label:'次月'
        }
      ],
      dataNum:[],
      selectedOptions: [],
      disabled: true,
      showCropAvatar: false,
      photo: "",
      releaseRules: {
        calpaydate: [
          { required: true, validator: this.validatorCalpayRules, trigger: "change"}
        ],
        socMonth: [{ required: true, message: "对应社保月份不能为空", trigger: "change" }],
        // 引用基本的 校验
        payDate: [
          { required: true, validator: this.validatorPayDate, trigger: "change" }
        ],
        payGroupId: [
          { required: true, validator: this.validatorOrg, trigger: "change"}
        ]
      },
      sexList: [{ value: "1", label: "女" }, { value: "2", label: "男" }],
      props: {
        // 配置项（必选）
        children: 'children',
        label: 'groupName',
        value: 'id',
      },
      treeList2: [
        /*{
          branchId: "HUB001",
          cusId: "0e5adece2a9940fda2b7c65deeb74f78",
          id: "441d5d60c3fb11e9806b00163e026f59",
          orgFormation: "500",
          orgName: "交付中心",
          page: 0,
          supId: "-1",
          children: [
            {
              branchId: "HUB001",
              children: [],
              cusId: "0e5adece2a9940fda2b7c65deeb74f78",
              id: "44a79fd1c3fb11e9806b00163e026f59",
              orgName: "中智智人",
              page: 0,
              size: 0,
              supId: "441d5d60c3fb11e9806b00163e026f59"
            },
            {
                branchId: "HUB001",
                children: [],
                cusId: "0e5adece2a9940fda2b7c65deeb74f78",
                id: "44a79fd1c3fb11e9806b00163e026f19",
                orgName: "测试1",
                page: 0,
                size: 0,
                supId: "441d5d60c3fb11e9806b00163e026f59"
            }
          ]
        },
        {
          branchId: "HUB001",
          cusId: "0e5adece2a9940fda2b7c65deeb74f78",
          id: "441d5d60c3fb11e9806b00163e026f58",
          orgFormation: "500",
          orgName: "集团",
          page: 0,
          supId: "-1",
          children: [
            {
              branchId: "HUB001",
              children: [],
              cusId: "0e5adece2a9940fda2b7c65deeb74f78",
              id: "44a79fd1c3fb11e9806b00163e026f54",
              orgName: "销售部",
              page: 0,
              size: 0,
              supId: "441d5d60c3fb11e9806b00163e026f58"
            }
          ]
        }*/
      ],
      valueId: null,
    };
  },
  methods: {
    //getOrgTree
    getOrgTree(cusId){
      queryCompanyOrgList(cusId).then(res=>{
        // console.log("=========================================="+JSON.stringify(res))
        this.treeList2 = res.data;//查询机构树
        console.log(this.treeList2)
      })
    },
    queryPmsPayGroupTree(){
      //不按薪酬组权限查询
      getGroupTree({}).then(res=>{
        this.treeList2 = res.data.data;//查询薪酬组树
      })
    },
    toggleShowCropAvatar() {
      this.showCropAvatar = !this.showCropAvatar;
    },
    handleUploadSuccess(res, field) {
      console.log(res);
      this.listForm.photo = res.fileId;
    },
    chagePayMonth(value){

      if(this.listForm.calpayStartMonth==commonConst.COMPANY_NEXT_MONTH){//开始为次月,
          this.listForm.calpayEndMonth =commonConst.COMPANY_NEXT_MONTH
      }
    },
    // 取值
    getValue({ valueId, valueTitle, name, node }){
      this.listForm.payGroupId = valueId;
      this.listForm.orgId = node.orgId;
    },
    handleChange(v){},
    clearTreeSelect(){
      if(this.$refs.orgId!=isNull){
        this.$refs.orgId.clearHandle()
      }
    },
    /**
     * 校验计薪周期
     */
    validatorCalpayRules(rule,value,callback){
      let param = this.listForm;
      if(param){
        if(param.calpayStartMonth && param.calpayStartMonth!=''
        && param.calpayStartDay && param.calpayStartDay!=''
        && param.calpayEndMonth && param.calpayEndMonth!=''
        && param.calpayEndDay && param.calpayEndDay!=''){
          if(param.calpayStartDay == param.calpayEndDay && param.calpayStartMonth == param.calpayEndMonth){
            callback('计薪周期开始结束时间不能一样');
          }
          if(param.calpayStartDay <= param.calpayEndDay && param.calpayStartMonth == param.calpayEndMonth ){
            callback();
          }else if( param.calpayStartMonth != param.calpayEndMonth ){
            if(param.calpayStartDay>=param.calpayEndDay){
              callback();
            }else{
              callback('计薪周期不能超过31天');
            }
          }else{
            callback('结束日期不能早于起始日期');
          }
        }else{
          callback('计薪周期不能为空');
        }
      }else{
        callback('计薪周期不能为空');
      }
    },
    /**
     * 校验发薪日期
     */
    validatorPayDate(rule, value, callback) {
      let param = this.listForm;
      if(param.payMonth && param.payMonth!='' && param.payDay && param.payDay!=''){
        callback();
      }else{
        callback('发薪日期不能为空');
      }
      return false;
    },
    /**
     * 校验所属机构
     */
    validatorOrg(rule, value, callback) {
      let param = this.listForm;
      if(param.orgId){
        callback();
      }else{
        callback('所属薪酬组不能为空');
      }
      return false;
    },
  }
};
</script>

<style scoped>
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-left: 30px;
  margin-bottom: 5px;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
  margin-left: 30px;
  margin-bottom: 5px;
}
</style>
